import {
  TiptapBase,
  Heading,
  BulletList,
  OrderedList,
  Bold,
  Italic,
  Strike,
  History,
  FontFamily,
  FontSize,
  Link,
  Underline,
  TextAlign,
  HardBreak,
  ListItem,
  Dropcursor,
  Gapcursor,
  TextStyle,
  PasteFromGoogleDocs,
  UpdateContent,
} from '@/js/util/tiptap/extensions';

import {
  FontFamilyHandlers,
  FontSizeHandlers,
  HeadingLevelHandlers,
  LinksHandlers,
  ListsHandlers,
  TextAlignmentHandlers,
  TextFormattingHandlers,
  PresetHandlers,
} from '@/js/util/tiptap/handlers';

export default class ApprovalTermsConfig {
  get extensions() {
    return [
      ...TiptapBase,
      ...Heading,
      ...BulletList,
      ...OrderedList,
      ...Bold,
      ...Italic,
      ...Strike,
      ...History,
      ...FontFamily,
      ...FontSize,
      ...Link,
      ...Underline,
      ...TextAlign,
      ...HardBreak,
      ...ListItem,
      ...Dropcursor,
      ...Gapcursor,
      ...TextStyle,
      ...PasteFromGoogleDocs,
      ...UpdateContent,
    ];
  }

  get handlers() {
    return {
      ...FontFamilyHandlers,
      ...FontSizeHandlers,
      ...HeadingLevelHandlers,
      ...LinksHandlers,
      ...ListsHandlers,
      ...TextAlignmentHandlers,
      ...TextFormattingHandlers,
      ...PresetHandlers,
    };
  }
}
